import './legend.css'

//
//  Takes in the colorMap and units passed form Legend.tsx, then generates the legend based on that information.
//

function LegendContent({ colorMap, units }) {
  let legend: HTMLElement[] = []
  if (colorMap) {
    const colors = colorMap.colors
    const values = colorMap.values
    const visibles = colorMap.visibles
    for (let i = 0; i < colors.length; i++) {
      const color = colors[i]
      let value = values[i]
      const visible = visibles[i]

      if (visible) {
        // May want to consider moving this logic into TemperatureLayer.
        switch (units) {
          case 'F':
            value = (value - 273.15) * (9 / 5) + 32 // Kelvin to Farenheit formula
            break
          case 'C':
            value = value - 273.15 // Kelvin to Celsius formula
            break
          default:
            value = value
            break
        }

        const newLegendBox = (
          <div className="legend-background" key={'legend-background-' + i}>
            <p
              className="legend-box"
              key={'legend-box-' + i}
              style={{ backgroundColor: color.str }}
            >
              {' '}
              {value.toFixed()} {units}
            </p>
          </div>
        )
        legend = [legend, newLegendBox]
      }
    }
    return <>{legend}</>
  }
}

export default LegendContent
